import React from "react";
import { Box, Text } from "@chakra-ui/react";

interface ParticipantPanelErrorBoundaryProps {
	children: React.ReactNode;
	participantName: string;
}

interface ParticipantPanelErrorBoundaryState {
	hasError: boolean;
}

// VT-010: a render throw anywhere inside one participant's accordion panel
// (e.g. an unexpected effective-settings/rule shape) must degrade that one
// panel, not blank the whole SPA. Scoped per-panel rather than page-wide so
// the other 18 participants (and the rest of the app — sidebar included)
// stay usable.
export class ParticipantPanelErrorBoundary extends React.Component<
	ParticipantPanelErrorBoundaryProps,
	ParticipantPanelErrorBoundaryState
> {
	constructor(props: ParticipantPanelErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(): ParticipantPanelErrorBoundaryState {
		return { hasError: true };
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
		// eslint-disable-next-line no-console
		console.error("Notification management panel render error:", error, errorInfo);
	}

	render(): React.ReactNode {
		if (this.state.hasError) {
			return (
				<Box p={4} data-testid="participant-panel-error">
					<Text color="red.500" fontSize="sm">
						Something went wrong showing notification settings for{" "}
						{this.props.participantName}. Other participants are unaffected.
					</Text>
				</Box>
			);
		}

		return this.props.children;
	}
}
